import { ECoworkingAccess } from 'shared/types/filters/advanced/coworkingAccess';

export const coworkingAccessLabelMap: Record<ECoworkingAccess, string> = {
  [ECoworkingAccess.AllDayAccess]: 'Круглосуточно',
  [ECoworkingAccess.AllWeekAccess]: 'В выходные дни',
};
